// Create a new hook in src/feature-module/books/bookRequest/hooks/useCreateBookRequest.ts

import { useState, useCallback } from "react";
import {
  BookRequestPayloadType,
  BookRequestResponseType,
} from "../types/bookRequestTypes";
import { showToast } from "../../../../core/utils/alert";
import { useSaveBookRequestMutation } from "../api/bookRequestApi";

export const useCreateBookRequest = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [saveBookRequest] = useSaveBookRequestMutation();

  const addBookRequest = useCallback(
    async (
      payload: BookRequestPayloadType
    ): Promise<{
      success: boolean;
      data?: BookRequestResponseType;
      error?: string;
    }> => {
      setIsLoading(true);
      try {
        const response = await saveBookRequest(payload).unwrap();

        if (response.success) {
          showToast({
            title: "Success",
            text: response.message || "Book request created successfully",
            icon: "success",
          });

          return {
            success: true,
            data: {
              id: response.data?.bookrequest?.id || 0,
              student_id: payload.student_id,
              student_name: "",
              course: "",
              stage: response.data?.bookrequest?.stage?.name,
              request_date: new Date().toISOString().split("T")[0],
              status: "pending",
            },
          };
        } else {
          throw new Error(response.message || "Failed to create book request");
        }
      } catch (err) {
        const errorMessage =
          err instanceof Error ? err.message : "Failed to create book request";
        showToast({
          title: "Error",
          text: errorMessage,
          icon: "error",
        });
        return { success: false, error: errorMessage };
      } finally {
        setIsLoading(false);
      }
    },
    [saveBookRequest]
  );

  return {
    addBookRequest,
    isLoading,
  };
};
